export default {
  // 询价管理
  inquiryManagement: {
    title: '询价管理',
    description: '管理客户询价需求和报价流程',

    enums: {
      // 枚举翻译
      inquiryTarget: {
        CLIENT: '商务',
        SUPPLIER: '供应商'
      },
      payment: {
        PREPAID: '预付',
        COLLECT: '到付',
        '1': '预付',
        '2': '到付',
        '3': '预付/到付'
      },
      airServiceType: {
        CONSOL: '散货',
        FULL_PALLET: '整板',
        BLOCK_SPACE: '整舱',
        FULL_CHARTER: '包机',
        '1': '散货',
        '2': '整板',
        '3': '整舱',
        '4': '包机'
      },
      railServiceType: {
        CONTAINER: '集装箱',
        TRUCK: '整车',
        BULK: '散货'
      },
      railRouteType: {
        MIDDLE: '中线',
        NORTH: '北线',
        SOUTH: '南线',
        SOUTHEAST_ASIA: '东南亚',
        CENTRAL_ASIA: '中亚',
        中线: '中线',
        北线: '北线',
        南线: '南线',
        东南亚: '东南亚',
        中亚: '中亚'
      }
    },

    // 标签页
    tabs: {
      fcl: '整箱询价',
      lcl: '拼箱询价',
      air: '空运询价',
      precarriage: '港前询价',
      oncarriage: '尾程询价',
      express: '快递询价',
      rail: '铁路询价'
    },

    // 工具栏按钮
    toolbar: {
      addInquiry: '新增询价',
      addFclInquiry: '新增整箱询价',
      addLclInquiry: '新增拼箱询价',
      addPrePortInquiry: '新增港前询价',
      addLastMileInquiry: '新增尾程询价',
      addExpressInquiry: '新增快递询价',
      addAirInquiry: '新增空运询价',
      addRailInquiry: '新增铁路询价',
      batchOperations: '批量操作 ({count})',
      batchExport: '批量导出',
      batchExportExcel: '批量导出Excel',
      batchExportCsv: '批量导出CSV',
      batchDelete: '批量删除'
    },

    // 表格列标题
    columns: {
      inquiryNo: '询价编号',
      source: '询价来源',
      inquirerId: '询价人',
      inquiryStatus: '询价状态',
      status: '询价状态',
      inquiryNature: '询价性质',
      businessType: '业务类型',
      targetSuppliers: '目标供应商',
      quotedSuppliers: '已报价',
      prePortQuotationStatus: '头程报价状态',
      trunkLineQuotationStatus: '干线报价状态',
      lastMileQuotationStatus: '尾程报价状态',
      consultationStatus: '磋商状态',
      quotationStatus: '报价状态',
      expressQuotationStatus: '快递报价状态',
      validPeriod: '有效期',
      loadMode: '装载模式',
      routeType: '路线类型',
      serviceType: '服务类型',
      paymentTerm: '付款方式',
      expressCarrier: '快递公司',
      transportTerms: '运输条款',
      expectedSailingTime: '期望开航时间',
      expectedTransitTime: '期望运输时效',
      seaEq: '箱型箱量',
      cargoReadyTime: '货好时间',
      palletNature: '货盘性质',
      carrierId: '船公司',
      directTransit: '直达/中转',
      routeId: '航线',
      loadingPortId: '起运港',
      loadingPort: '起运港',
      dischargingPortId: '卸货港',
      destinationPortId: '卸货港',
      destinationPort: '卸货港',
      cargoType: '货物类型',
      cargoInfo: '货物信息',
      originAddress: '发货地',
      destinationAddress: '目的地',
      loadingAirportId: '起运机场',
      destinationAirportId: '目的机场',
      airCarrierId: '航空公司',
      railCarrierId: '铁路公司',
      railRouteType: '线路分类',
      loadingRailwayStationId: '起运站',
      destinationStationId: '目的站',
      quantity: '件数',
      unNo: 'UN编号',
      hazardClass: '类别',
      cargoDescription: '品名',
      hsCode: 'HS CODE',
      cargoValue: '货值',
      cargoValueCurrency: '货值币种',
      onePriceSupported: '一口价',
      deadLine: '报价截止时间',
      specialRequirements: '特殊要求',
      weight: '重量(KGS)',
      cubage: '体积(CBM)',
      totalQuantity: '件数',
      totalWeight: '毛重(KGS)',
      totalCubage: '体积(CBM)',
      etd: 'ETD',
      eta: 'ETA',
      serviceTerm: '服务条款',
      clientType: '委托单位类型',
      clientTitle: '委托单位名称',
      remarks: '备注',
      createdBy: '创建人',
      dateCreated: '创建时间',
      submitDate: '询价时间',
      modifiedBy: '修改人',
      dateModified: '修改时间',
      quotationType: '报价类型',
      inquiryTargetIds: '报价名称',
      actions: '操作'
    },

    // 筛选占位符
    placeholders: {
      quotationType: '请选择报价类型'
    },

    express: {
      pageTitle: {
        create: '新增快递询价',
        edit: '编辑快递询价',
        view: '查看快递询价',
        copy: '复制快递询价'
      },
      sections: {
        ai: 'AI识别',
        basic: '基本信息',
        origin: '发货地',
        destination: '目的地',
        route: '路线信息',
        cargo: '货物信息',
        requirement: '报价要求'
      },
      fields: {
        inquiryType: '询价类型',
        inquiryNature: '询价性质',
        paymentTerm: '付款方式',
        loadMode: '装载模式',
        expressCarrier: '快递公司',
        serviceType: '服务类型',
        onePriceSupported: '一口价',
        onePriceSupportedTip: '开启后，供应商报价时可填写全包一口价',
        cargoType: '货物类型',
        source: '询价来源',
        palletNature: '货盘性质',
        clientType: '委托单位类型',
        client: '委托单位',
        clientTitle: '委托单位名称',
        cargoReadyTimeType: '货好时间类型',
        cargoReadyTimeRange: '货好时间区间',
        cargoReadyTimeDate: '货好时间',
        expectedSailingTime: '期望开航时间',
        deadLine: '报价截止时间',
        specialRequirements: '特殊要求',
        transportTerms: '贸易条款',
        originCountry: '发货国家',
        originProvince: '发货省/州',
        originCity: '发货城市',
        originDistrict: '发货区/县',
        originStreet: '发货街道',
        originDetail: '发货详细地址',
        originPostalCode: '发货邮编',
        destCountry: '目的国家',
        destProvince: '目的省/州',
        destCity: '目的城市',
        destDistrict: '目的区/县',
        destStreet: '目的街道',
        destDetail: '目的详细地址',
        destPostalCode: '目的邮编',
        postalCode: '邮编',
        routeType: '路线类型',
        quantity: '件数',
        weight: '重量',
        actualWeight: '实际重量(KGS)',
        actualTotalWeight: '实际总重量(KGS)',
        totalWeight: '货物总重量(KGS)',
        totalWeightTon: '货物总重量(吨)',
        cubage: '体积',
        totalCubage: '总体积(CBM)',
        length: '长',
        lengthCm: '长(CM)',
        width: '宽',
        widthCm: '宽(CM)',
        height: '高',
        heightCm: '高(CM)',
        dimensions: '单件尺寸(cm)',
        cargoDescription: '货物描述',
        cargoName: '品名',
        unNo: 'UN 编号',
        hazardClass: '类别',
        hsCode: 'HSCODE',
        cargoValue: '货值',
        country: '国家',
        province: '州/省',
        city: '市',
        district: '区/县',
        street: '乡/镇/街道',
        community: '社区',
        detailAddress: '详细地址',
        warehouse: '仓库',
        needPickup: '需要提货',
        needDelivery: '需要送货',
        needUpstairs: '需要上楼',
        needLoadingUnloading: '需要装卸',
        expectedVehicleType: '期望车型',
        expectedTransitTime: '期望时效',
        pricingPreference: '计费方式偏好',
        needSupplierProvide: '需要供应商提供',
        remarks: '备注'
      },
      actions: {
        saveDraft: '保存草稿',
        submit: '提交询价',
        back: '返回',
        recognize: '识别',
        uploadRecognize: '上传识别',
        matchRates: '查询匹配运价',
        reset: '重置',
        uploadFile: '上传文件',
        pasteText: '粘贴文本',
        recognizing: '识别中...',
        clear: '清除',
        addCargo: '添加货物'
      },
      ai: {
        uploadTitle: '点击或拖拽上传快递询价文件',
        uploadDesc: '支持 JPG/PNG/PDF/Excel/Word 格式',
        recognizedCount: '已识别 {count} 个字段'
      },
      placeholders: {
        aiText: '粘贴快递询价文本，AI会尝试回填路线、货物和要求信息',
        input: '请输入',
        select: '请选择'
      },
      options: {
        common: {
          any: '不限'
        },
        specialRequirements: {
          signReceipt: '签收回单',
          insurance: '保价',
          cod: '代收货款',
          none: '无'
        },
        transitTime: {
          standard: '标快',
          express: '特快',
          nextDay: '次日达',
          daysThreeToFive: '3-5天',
          daysFiveToSeven: '5-7天',
          withinOneDay: '1天内',
          daysTwoToThree: '2-3天'
        },
        pricingPreference: {
          firstAdditional: '首重+续重报价',
          weightTier: '重量段报价',
          weightVolumeUnit: '单件报价（重/泡双计）',
          trip: '按车次一口价',
          km: '按里程计费'
        },
        vehicleType: {
          fourTwo: '4.2米',
          sixEight: '6.8米',
          nineSix: '9.6米',
          thirteen: '13米',
          seventeenFive: '17.5米'
        }
      },
      messages: {
        loadFailed: '加载快递询价失败',
        saveSuccess: '快递询价保存成功',
        saveFailed: '快递询价保存失败',
        resetSuccess: '已重置',
        aiTextRequired: '请先输入需要识别的文本',
        aiFileRequired: '请先上传需要识别的文件',
        aiSuccess: 'AI识别完成',
        aiFailed: 'AI识别失败',
        matchRatesLoading: '正在查询匹配运价...',
        matchRatesEmpty: '暂无匹配运价，请调整查询条件',
        matchRatesSuccess: '找到 {count} 条匹配运价',
        matchRatesFailed: '查询匹配运价失败',
        rateSelected: '已选择运价',
        matchRequiredOrigin: '请先填写发货地',
        matchRequiredDestination: '请先填写目的地',
        originAddressRequired: '发货仓库或详细地址至少填写一项',
        destinationAddressRequired: '目的仓库或详细地址至少填写一项',
        deadlineFutureRequired: '报价截止时间必须晚于当前时间',
        cargoRowsRequired: '请完整填写第 {index} 行货物信息'
      },
      matchRates: {
        title: '匹配运价',
        selected: '已选择',
        recommended: '推荐',
        noLimit: '匹配全部',
        billingDetail: '计费规则',
        surcharge: '附加费',
        validity: '有效期',
        surchargeCount: '{count} 项附加费'
      },
      detail: {
        title: '快递询价详情',
        totalQuotes: '共 {count} 家报价',
        sentSuppliersWithCount: '已发送供应商 ({count}家)',
        contact: '联系人',
        quotedAt: '报价时间',
        sections: {
          inquiryInfo: '询价信息',
          quotationSummary: '报价汇总',
          negotiationRecords: '磋商记录'
        },
        columns: {
          carrier: '快递公司',
          serviceType: '服务类型',
          billingModel: '计费模型',
          billingWeight: '计费重量',
          baseFreight: '基础运费',
          minCharge: '最低消费',
          chargeableBase: '计费基础运费',
          surchargeTotal: '附加费',
          totalAmount: '综合费用',
          validPeriod: '有效期',
          confirmStatus: '确认状态',
          consultStatus: '磋商状态',
          importStatus: '导入状态',
          consultationCount: '磋商',
          chargeName: '费用名称',
          billingMode: '计费模式',
          amount: '金额'
        },
        actions: {
          refresh: '刷新',
          confirmSupplier: '确认供应商',
          cancelConfirm: '取消确认',
          negotiate: '磋商',
          importRate: '导入运价'
        },
        status: {
          unconfirmed: '未确认',
          confirmed: '已确认',
          imported: '已导入',
          notImported: '未导入'
        },
        tags: {
          recommended: '推荐'
        },
        supplierStatus: {
          imported: '已入库',
          quoted: '已报价',
          pendingQuote: '待报价'
        },
        help: {
          beforeConfirm: '未确认报价可以发起磋商；磋商中的报价不可重复发起、确认供应商或导入运价。',
          afterConfirm: '确认供应商后不可磋商，可以导入运价或取消确认。',
          afterImport: '导入运价后不可重复导入或磋商；已确认报价仍可取消确认。'
        },
        modal: {
          quotationDetail: '报价详情',
          pricingDetails: '报价明细',
          calculation: '计算明细',
          surchargeItems: '附加费明细',
          unlimited: '不限',
          initiateConsultation: '发起磋商',
          consultationRecords: '磋商记录',
          supplier: '供应商',
          quotationNo: '报价方案',
          currentPrice: '当前报价',
          expectedPrice: '期望价格',
          expectedPricePlaceholder: '请输入期望价格，支持多币种文本',
          consultationNote: '磋商说明',
          consultationNotePlaceholder: '请输入本轮磋商说明',
          consultationRound: '第{round}轮'
        },
        confirm: {
          cancelTitle: '取消确认',
          cancelContent: '确认取消当前已确认供应商吗？',
          importTitle: '导入运价',
          importContent: '确认将当前报价导入快递运价维护吗？'
        },
        messages: {
          loadQuotationFailed: '快递报价加载失败',
          selectQuotationFirst: '请先选择一条报价',
          confirmConsultingDisabled: '磋商中的报价不可确认供应商',
          confirmUnavailable: '当前报价状态不可确认供应商',
          confirmSuccess: '供应商确认成功',
          confirmFailed: '供应商确认失败',
          cancelConfirmSuccess: '已取消确认',
          cancelConfirmFailed: '取消确认失败',
          importSuccess: '已导入运价维护',
          importFailed: '导入运价失败',
          importConsultingDisabled: '未确认且磋商中的报价不可导入运价',
          importUnavailable: '当前报价状态不可导入运价',
          consultSuccess: '已发起磋商',
          consultFailed: '发起磋商失败',
          consultUnavailable: '当前报价状态不可磋商',
          confirmedNegotiateDisabled: '已确认供应商的报价不可磋商',
          importedNegotiateDisabled: '已导入运价的报价不可磋商',
          consultingNegotiateDisabled: '报价正在磋商中，请等待供应商回复',
          expectedPriceRequired: '请填写期望价格',
          loadConsultationFailed: '磋商记录加载失败'
        },
        emptyNegotiation: '暂无磋商记录'
      }
    },

    air: {
      pageTitle: {
        create: '新增空运询价',
        edit: '编辑空运询价',
        view: '查看空运询价',
        copy: '复制空运询价',
        tag: '空运 Air'
      },
      sections: {
        basic: '基本信息',
        route: '航线信息',
        cargo: '货物信息',
        dangerous: '危险品信息',
        serviceType: '服务类型字段组',
        serviceBulk: '散货信息',
        servicePallet: '整板信息',
        serviceCharterSpace: '整舱信息',
        serviceFullCharter: '包机信息',
        prePort: '港前提货地址',
        lastMile: '尾程送货地址',
        requirement: '报价要求',
        ai: 'AI 识别回填',
        special: '特殊要求'
      },
      fields: {
        inquiryNature: '询价性质',
        paymentMethod: '付款方式',
        paymentTerm: '付款方式',
        serviceType: '服务类型',
        serviceTerm: '服务条款',
        transportTerm: '运输条款',
        cargoReadyTime: '货好时间',
        cargoReadyTimeType: '货好时间类型',
        cargoType: '货物类型',
        hsCode: 'HSCODE',
        cargoValue: '货值',
        onePriceSupported: '一口价',
        onePriceSupportedTip: '全包价格',
        deadLine: '报价截止',
        quoteDeadline: '报价截止时间',
        carrier: '航空公司',
        airline: '航空公司',
        createdBy: '创建人',
        dateCreated: '创建时间',
        specialRequirements: '特殊要求',
        remarks: '备注',
        loadingCountry: '起运国',
        loadingCity: '起运城市',
        loadingAirport: '起飞机场',
        destinationCountry: '目的国',
        destinationCity: '目的城市',
        destinationAirport: '目的机场',
        originCountry: '起运国',
        originCity: '起运城市',
        originAirport: '起运机场',
        destCountry: '目的国',
        destCity: '目的城市',
        destAirport: '目的机场',
        quantity: '件数',
        weight: '毛重',
        length: '长',
        width: '宽',
        height: '高',
        palletCount: '板数',
        inquiryNo: '询价编号',
        inquirySource: '询价来源',
        inquirer: '询价人',
        inquiryStatus: '询价状态',
        quoteTarget: '报价对象',
        targetType: '对象类型',
        prePortQuoteStatus: '港前报价状态',
        trunkQuoteStatus: '干线报价状态',
        lastMileQuoteStatus: '尾程报价状态',
        negotiationStatus: '磋商状态',
        clientName: '委托单位',
        clientType: '委托单位类型',
        clientTitle: '委托单位名称',
        directTransit: '直达/中转',
        expectedDeparture: '期望开航时间',
        unNumber: 'UN编号',
        hazardClass: '危险品类别',
        hazardName: '危险品名称',
        productName: '品名',
        cargoValueCurrency: '货值币种',
        country: '国家',
        province: '省/州',
        city: '市',
        district: '区/县',
        street: '乡/镇/街道',
        detailAddress: '详细地址',
        postalCode: '邮编',
        contactName: '联系人',
        contactPhone: '联系电话',
        airportStation: '起运机场货站',
        destAirportStation: '目的机场货站',
        deliveryAddressType: '配送类型',
        fbaCode: 'FBA代码',
        warehouseCode: '易仓编码',
        pieces: '件数',
        unitPieces: '单种件数',
        unitGrossWeight: '单件毛重(KGS)',
        lengthCm: '长(CM)',
        widthCm: '宽(CM)',
        heightCm: '高(CM)',
        packageType: '包装方式',
        temperature: '温度范围(℃)',
        temperatureSimple: '温度(℃)',
        ventilationDoor: '通风门',
        airflow: '风量',
        humidity: '湿度(%RH)',
        preCooling: '是否预冷',
        totalPieces: '总件数',
        totalWeight: '总毛重(KGS)',
        totalVolume: '总体积(CBM)',
        uldType: '航空板型',
        piecesPerPallet: '单板件数',
        grossWeightPerPallet: '单板毛重(KGS)',
        volumePerPallet: '单板体积(CBM)',
        palletLength: '单板长(CM)',
        palletWidth: '单板宽(CM)',
        palletHeight: '单板高(CM)',
        uldEquipment: '集装设备',
        exclusiveCabin: '是否独占货舱',
        maxLength: '单件最大长(CM)',
        maxWidth: '单件最大宽(CM)',
        maxHeight: '单件最大高(CM)',
        handlingRequirements: '装卸要求',
        preferredAircraft: '偏好机型',
        aircraftName: '机型名称',
        estimatedTotalWeight: '预计总重量(KGS)',
        estimatedTotalVolume: '预计总体积(CBM)',
        grossWeight: '毛重(KGS)',
        volume: '体积(CBM)'
      },
      actions: {
        matchRates: '查询匹配运价',
        reset: '重置',
        saveDraft: '保存草稿',
        publish: '直接发布',
        submit: '提交询价',
        back: '返回列表',
        recognize: '开始识别',
        clear: '清除',
        uploadFile: '上传文件',
        pasteText: '粘贴文本',
        recognizing: '识别中...',
        addContainerGroup: '新增箱组',
        delete: '删除',
        send: '发送',
        switchToAi: '切换至 AI 识别',
        clearChat: '清空对话',
        confirm: '确认'
      },
      placeholders: {
        input: '请输入',
        select: '请选择',
        optional: '选填',
        autoGenerate: '系统自动生成',
        currentUser: '当前登录用户',
        autoInferTargetType: '根据报价对象自动推导',
        clientName: '委托单位名称',
        selectClientType: '请选择委托单位类型',
        selectClient: '请选择委托单位',
        enterClientTitle: '请输入委托单位名称',
        multiAirline: '可不指定，支持多选',
        searchAirport: '输入机场代码搜索',
        selectDate: '选择日期',
        selectRange: '选择区间',
        expectedDeparture: '期望开航',
        unNumber: '如: UN1203',
        hazardName: '危险品品名',
        customsCode: '海关编码',
        productName: '货物品名',
        declareValue: '申报价值',
        deadline: '截止时间',
        remark: '请输入备注',
        remarkDisplay: '补充说明，会显示在货代的报价页面中',
        remarkInput: '请输入备注信息',
        station: '请选择货站',
        country: '请选择国家',
        province: '请选择省/州',
        city: '请选择市',
        district: '区/县',
        street: '乡/镇/街道',
        detailAddress: '门牌/楼层/具体位置',
        postalCode: '邮编',
        contactName: '联系人姓名',
        contactPhone: '联系电话',
        phone: '电话',
        fbaCode: '如: LAX9, ONT8',
        warehouseCode: '易仓仓库编码',
        aiText: '请粘贴需要识别的文本内容，例如：\n从 PVG/上海浦东 到 LAX/洛杉矶\n航空公司：国航\n货物：3件，毛重 150 KGS，体积 1.2 CBM\n货物类型：普货\n服务条款：DAP',
        chatInput: '输入消息...',
        uldExample: '如：AKE、PMC、PAG 等',
        quantity: '数量',
        packageType: '请选择包装方式',
        handling: '叉车、吊车、平台等',
        handlingFull: '叉车、吊车、平台等地面操作要求',
        temperature: '温度',
        airflow: '风量',
        humidity: '湿度',
        length: '长',
        width: '宽',
        height: '高',
        pieces: '件数',
        weight: '毛重',
        volume: '体积',
        palletCount: '板数',
        uldType: '请选择板型',
        aircraftType: '请选择机型',
        aircraftName: '输入机型',
        autoCalc: '自动计算',
        totalWeight: '总重量',
        totalVolume: '总体积',
        selectOrInput: '请选择或输入',
        selectOptional: '请选择（选填）',
        tempExample: '如-18'
      },
      options: {
        quoteSegment: {
          trunk: '干线价格',
          prePort: '港前价格',
          lastMile: '尾程价格'
        },
        inquirySource: {
          manual: '手动录入',
          customer: '客户发起',
          system: '系统自动'
        },
        inquiryStatus: {
          draft: '草稿',
          submitted: '已提交',
          quoting: '报价中',
          completed: '已完成',
          cancelled: '已取消'
        },
        quoteTarget: {
          broker: '商务',
          supplier: '供应商'
        },
        quoteStatus: {
          pending: '待报价',
          quoted: '已报价',
          confirmed: '已确认',
          na: '不适用'
        },
        negotiationStatus: {
          none: '未磋商',
          negotiating: '磋商中',
          completed: '已磋商完成'
        },
        inquiryNature: {
          pricing: '核价',
          formal: '正式询价'
        },
        paymentTerm: {
          prepaid: '预付',
          collect: '到付',
          prepaidCollect: '预付到付'
        },
        transportTermAir: {
          aa: 'A-A (机场-机场)',
          da: 'D-A (门-机场)',
          ad: 'A-D (机场-门)',
          dd: 'D-D (门-门)'
        },
        directTransit: {
          any: '不限',
          direct: '直达',
          transit: '中转'
        },
        cargoReadyType: {
          date: '指定日期',
          range: '时间区间'
        },
        cargoType: {
          normal: '普货',
          dangerous: '危险品',
          cold: '冷链',
          special: '特货',
          live: '鲜活'
        },
        hazardClass: {
          c1: '第1类 爆炸品',
          c2: '第2类 气体',
          c3: '第3类 易燃液体',
          c4: '第4类 易燃固体',
          c5: '第5类 氧化物质',
          c6: '第6类 毒性物质',
          c7: '第7类 放射性物质',
          c8: '第8类 腐蚀品',
          c9: '第9类 杂项'
        },
        packageType: {
          carton: '纸箱',
          wooden: '木箱',
          wooden_case: '木箱',
          wooden_box: '木箱',
          pallet: '托盘',
          bulk: '散货',
          bag: '袋装',
          woven_bag: '编织袋',
          drum: '桶装',
          roll: '卷',
          naked: '裸装',
          other: '其他',
          crate: '板条箱',
          bundle: '捆装'
        },
        deliveryAddressType: {
          amazon: '亚马逊仓库',
          yicang: '易仓',
          thirdParty: '第三方地址'
        },
        openClose: {
          open: '开',
          close: '关'
        },
        aircraft: {
          allCargo: '全货机',
          passengerCargo: '客货机(腹舱)',
          custom: '自定义机型'
        },
        uldType: {
          P1P: 'P1P (标准航空板)',
          P6P: 'P6P (高板)',
          PAJ: 'PAJ (窄板)',
          PGA: 'PGA (标准板)',
          PAC: 'PAC (结构板)',
          AKE: 'AKE (LD-3集装箱)',
          AKH: 'AKH (LD-3高箱)',
          AVE: 'AVE (LD-6集装箱)',
          AMA: 'AMA (M1集装箱)'
        },
        serviceTypeForm: {
          consol: '散货',
          bulk: '散货',
          fullPallet: '整板',
          pallet: '整板',
          blockSpace: '整舱',
          charterSpace: '整舱',
          fullCharter: '包机'
        }
      },
      messages: {
        loadFailed: '加载空运询价失败',
        saveDraftSuccess: '草稿保存成功',
        saveDraftFailed: '保存草稿失败',
        publishSuccess: '空运询价单已发布',
        publishFailed: '发布询价失败',
        submitSuccess: '空运询价提交成功',
        submitFailed: '提交询价失败',
        resetSuccess: '已重置表单',
        emailSent: '询价邮件已发送',
        emailNotAvailable: '询价邮件发送功能暂不可用',
        matchRatesComingSoon: '空运运价匹配功能即将上线',
        matchRatesSuccess: '找到 {count} 条匹配运价',
        matchRatesFailed: '查询匹配运价失败',
        aiComingSoon: 'AI 识别功能即将上线',
        requiredFieldsPrefix: '请完善必填项：',
        selectServiceTypeFirst: '请先选择服务类型',
        allInPriceTip: '开启后，供应商报价时可填写全包一口价',
        totalSummary: '合计：{pieces} 件 / {weight} KGS / {volume} CBM',
        densitySummary: '密度：{density} KG/CBM',
        priceSegmentEnabled: '干线、港前、尾程价格至少开启一个',
        priceSegmentActive: '价格段已启用',
        deadlineFutureRequired: '报价截止时间必须晚于当前时间'
      },
      ai: {
        uploadTitle: '点击或拖拽上传询价文件',
        uploadDesc: '支持 JPG/PNG/PDF/Excel/Word 格式',
        tip: '如仅询价港前费用与尾程费用，请在提供的信息前分别标明「港前」「尾程」。',
        recognizedCount: '已识别 {count} 个字段',
        confirmLowConfidence: '请确认'
      },
      matchRates: {
        title: '匹配运价',
        empty: '暂无匹配运价',
        valid: '有效',
        expiringSoon: '即将过期',
        unitPrice: '单价',
        minCharge: '最低消费',
        flight: '航班',
        pending: '待定',
        validity: '有效期',
        route: '航线'
      },
      agent: {
        title: 'Agent 询价',
        greeting: '您好！我来帮您填写空运询价单。<br />请问这次货物要从哪个机场发往哪个机场？大概有多重？',
        send: '发送',
        switchToAi: '切换至 AI 识别',
        clearChat: '清空对话'
      },
      detail: {
        title: '空运询价详情',
        totalQuotes: '共 {count} 家报价',
        sentSuppliersWithCount: '已发送供应商 ({count}家)',
        contact: '联系人',
        quotedAt: '报价时间',
        sections: {
          inquiryInfo: '询价信息',
          quotationSummary: '报价汇总'
        },
        columns: {
          supplier: '供应商',
          quotationNo: '报价编号',
          serviceType: '服务类型',
          flightNo: '航班号',
          charges: '费用',
          validPeriod: '有效期',
          submitDate: '提交时间',
          routeLevel: '航线等级',
          flightDepartureTime: '起飞时间',
          flightArrivalTime: '落地时间',
          chargeName: '费用项',
          unitRate: '单价',
          amount: '金额',
          confirmStatus: '确认状态',
          consultStatus: '磋商状态'
        },
        actions: {
          refresh: '刷新',
          confirmSupplier: '确认供应商',
          cancelConfirm: '取消确认',
          negotiate: '磋商'
        },
        status: {
          unconfirmed: '未确认',
          confirmed: '已确认',
          imported: '已入库',
          quoted: '已报价',
          pending: '待报价',
          notConsulted: '未磋商',
          consulting: '磋商中',
          consultCompleted: '磋商完成'
        },
        help: {
          beforeConfirm: '确认供应商前可发起磋商与供应商沟通价格细节。',
          afterConfirm: '确认供应商后可取消确认重新选择。'
        },
        modal: {
          quotationDetail: '报价详情',
          charges: '费用明细',
          noCharges: '暂无费用',
          initiateConsultation: '发起磋商',
          expectedPrice: '期望价格',
          expectedPricePlaceholder: '请输入期望价格',
          consultationNote: '磋商说明'
        },
        confirm: {
          cancelTitle: '取消确认',
          cancelContent: '确认取消当前已确认供应商吗？'
        },
        messages: {
          loadQuotationFailed: '空运报价加载失败',
          selectQuotationFirst: '请先选择一条报价',
          confirmSuccess: '供应商确认成功',
          confirmFailed: '供应商确认失败',
          cancelConfirmSuccess: '已取消确认',
          cancelConfirmFailed: '取消确认失败',
          consultSuccess: '已发起磋商',
          consultFailed: '发起磋商失败',
          consultUnavailable: '当前报价状态不可磋商',
          expectedPriceRequired: '请填写期望价格'
        }
      }
    },

    rail: {
      pageTitle: {
        create: '新增铁路询价',
        edit: '编辑铁路询价',
        view: '查看铁路询价',
        copy: '复制铁路询价',
        tag: '铁路 Rail'
      },
      sections: {
        basic: '基本信息',
        route: '路线信息',
        cargo: '货物信息',
        dangerous: '危险品信息',
        serviceType: '服务类型',
        serviceBulk: '散货信息',
        servicePallet: '整板信息',
        serviceCharterSpace: '整舱信息',
        serviceFullCharter: '包机信息',
        containerGroup: '箱组',
        prePort: '港前提货地址',
        lastMile: '尾程送货地址',
        requirement: '报价要求',
        ai: 'AI 识别回填',
        special: '特殊要求'
      },
      fields: {
        inquiryNature: '询价性质',
        paymentTerm: '付款方式',
        serviceType: '服务类型',
        routeType: '线路分类',
        lineCategory: '线路分类',
        serviceTerm: '服务条款',
        transportTerm: '运输条款',
        cargoReadyTime: '货好时间',
        cargoReadyTimeType: '货好时间类型',
        cargoType: '货物类型',
        hsCode: 'HSCODE',
        cargoValue: '货值',
        onePriceSupported: '一口价',
        onePriceSupportedTip: '全包价格',
        quotationDeadline: '报价截止',
        quoteDeadline: '报价截止时间',
        needCustomsClearance: '需要报关',
        needInsurance: '需要保险',
        carrier: '承运人',
        railwayCompany: '铁路公司',
        createdBy: '创建人',
        dateCreated: '创建时间',
        specialRequirements: '特殊要求',
        remarks: '备注',
        loadingCountry: '起运国',
        loadingCity: '起运城市',
        loadingStation: '起运站',
        destinationCountry: '目的国',
        destinationCity: '目的城市',
        destinationStation: '目的站',
        originCountry: '起运国',
        originCity: '起运城市',
        originStation: '起运站',
        destCountry: '目的国',
        destCity: '目的城市',
        destStation: '目的站',
        containerType: '箱型',
        containerNum: '箱量',
        quantity: '件数',
        weight: '毛重',
        length: '长',
        width: '宽',
        height: '高',
        inquiryNo: '询价编号',
        inquirySource: '询价来源',
        inquirer: '询价人',
        inquiryStatus: '询价状态',
        quoteTarget: '报价对象',
        targetType: '对象类型',
        clientName: '委托单位',
        clientType: '委托单位类型',
        clientTitle: '委托单位名称',
        directTransit: '直达/中转',
        unNumber: 'UN编号',
        hazardClass: '危险品类别',
        productName: '品名',
        cargoValueCurrency: '货值币种',
        country: '国家',
        province: '省/州',
        city: '市',
        district: '区/县',
        street: '乡/镇/街道',
        detailAddress: '详细地址',
        postalCode: '邮编',
        contactName: '联系人',
        contactPhone: '联系电话',
        railStation: '起运铁路货站',
        destRailStation: '目的铁路货站',
        pieces: '件数',
        grossWeight: '毛重(KGS)',
        volume: '体积(CBM)',
        packageType: '包装方式',
        temperature: '温度(℃)',
        ventilationDoor: '通风门',
        airflow: '风量(m³/h)',
        humidity: '湿度(%RH)',
        preCooling: '预冷',
        truckType: '整车类型',
        vehicleCount: '车辆数量',
        totalPieces: '总件数',
        totalWeight: '总毛重(KGS)',
        totalVolume: '总体积(CBM)'
      },
      actions: {
        matchRates: '查询匹配运价',
        reset: '重置',
        saveDraft: '保存草稿',
        publish: '直接发布',
        submit: '提交询价',
        back: '返回列表',
        recognize: '开始识别',
        clear: '清除',
        uploadFile: '上传文件',
        pasteText: '粘贴文本',
        recognizing: '识别中...',
        addContainerGroup: '新增箱组',
        delete: '删除',
        send: '发送',
        switchToAi: '切换至 AI 识别',
        clearChat: '清空对话',
        confirm: '确认'
      },
      placeholders: {
        input: '请输入',
        select: '请选择',
        optional: '选填',
        autoGenerate: '系统自动生成',
        currentUser: '当前登录用户',
        autoInferTargetType: '根据报价对象自动推导',
        clientName: '委托单位名称',
        selectClientType: '请选择委托单位类型',
        selectClient: '请选择委托单位',
        enterClientTitle: '请输入委托单位名称',
        multiAirline: '可不指定，支持多选',
        searchAirport: '输入代码搜索',
        selectDate: '选择日期',
        selectRange: '选择区间',
        expectedDeparture: '期望发车',
        unNumber: '如: UN1203',
        hazardName: '危险品品名',
        customsCode: '海关编码',
        productName: '货物品名',
        declareValue: '申报价值',
        deadline: '截止时间',
        remark: '备注',
        remarkDisplay: '补充说明，会显示在货代的报价页面中',
        remarkInput: '请输入备注信息',
        station: '请选择货站',
        country: '请选择国家',
        province: '请选择省/州',
        city: '请选择市',
        district: '区/县',
        street: '乡/镇/街道',
        detailAddress: '门牌/楼层/具体位置',
        postalCode: '邮编',
        contactName: '联系人姓名',
        contactPhone: '联系电话',
        phone: '电话',
        fbaCode: '如: LAX9, ONT8',
        warehouseCode: '仓库编码',
        aiText: '请粘贴需要识别的文本内容，例如：\n从 上海闵行站 到 杜伊斯堡\n铁路公司：中铁集装箱\n线路：中线\n服务：集装箱\n柜型：40HC',
        chatInput: '输入消息...',
        uldExample: '如：AKE、PMC、PAG 等',
        quantity: '箱量',
        packageType: '请选择包装方式',
        handling: '叉车、吊车、平台等',
        handlingFull: '叉车、吊车、平台等地面操作要求',
        temperature: '温度',
        airflow: '风量',
        humidity: '湿度',
        length: '长',
        width: '宽',
        height: '高',
        pieces: '件数',
        weight: '毛重',
        volume: '体积',
        palletCount: '板数',
        uldType: '请选择板型',
        aircraftType: '请选择机型',
        aircraftName: '输入机型',
        autoCalc: '自动计算',
        totalWeight: '总重量',
        totalVolume: '总体积',
        selectOrInput: '请选择或输入',
        selectOptional: '请选择（选填）',
        tempExample: '如-18'
      },
      options: {
        quoteSegment: {
          trunk: '干线价格',
          prePort: '港前价格',
          lastMile: '尾程价格'
        },
        inquirySource: {
          manual: '手动录入',
          customer: '客户发起',
          system: '系统自动'
        },
        inquiryStatus: {
          draft: '草稿',
          submitted: '已提交',
          quoting: '报价中',
          completed: '已完成',
          cancelled: '已取消'
        },
        quoteTarget: {
          broker: '商务',
          supplier: '供应商'
        },
        quoteStatus: {
          pending: '待报价',
          quoted: '已报价',
          confirmed: '已确认',
          na: '不适用'
        },
        negotiationStatus: {
          none: '未磋商',
          negotiating: '磋商中',
          completed: '已磋商完成'
        },
        inquiryNature: {
          pricing: '核价',
          formal: '正式询价'
        },
        paymentTerm: {
          prepaid: '预付',
          collect: '到付',
          prepaidCollect: '预付到付'
        },
        transportTermRail: {
          cycy: 'CY-CY (站-站)',
          doordoor: 'DOOR-DOOR (门-门)',
          cydoor: 'CY-DOOR (站-门)',
          doorcy: 'DOOR-CY (门-站)'
        },
        directTransit: {
          any: '不限',
          direct: '直达',
          transit: '中转'
        },
        cargoReadyType: {
          date: '指定日期',
          range: '时间区间'
        },
        cargoType: {
          normal: '普货',
          dangerous: '危险品',
          cold: '冷链',
          special: '特货',
          live: '鲜活'
        },
        hazardClass: {
          c1: '第1类 爆炸品',
          c2: '第2类 气体',
          c3: '第3类 易燃液体',
          c4: '第4类 易燃固体',
          c5: '第5类 氧化物质',
          c6: '第6类 毒性物质',
          c7: '第7类 放射性物质',
          c8: '第8类 腐蚀品',
          c9: '第9类 杂项'
        },
        packageType: {
          carton: '纸箱',
          wooden: '木箱',
          wooden_case: '木箱',
          wooden_box: '木箱',
          pallet: '托盘',
          bulk: '散货',
          bag: '袋装',
          woven_bag: '编织袋',
          drum: '桶装',
          roll: '卷',
          naked: '裸装',
          other: '其他',
          crate: '板条箱',
          bundle: '捆装'
        },
        deliveryAddressType: {
          amazon: '亚马逊仓库',
          yicang: '易仓',
          thirdParty: '第三方地址'
        },
        openClose: {
          open: '开',
          close: '关'
        },
        truckType: {
          boxcar: '棚车',
          flatcar: '平车',
          openCar: '敞车',
          boxcarHc: '高边车'
        },
        vehicleType: {
          openCar: '敞车',
          boxcar: '棚车',
          flatcar: '平车',
          reefer: '冷藏车',
          ore: '矿石车',
          cement: '水泥车'
        },
        railServiceTypeForm: {
          container: '集装箱',
          fullLoad: '整车',
          bulk: '散货'
        },
        lineCategory: {
          central: '中线',
          north: '北线',
          south: '南线',
          southeastAsia: '东南亚',
          centralAsia: '中亚'
        },
        railwayCompany: {
          CRCT: '中铁集装箱 (CRCT)',
          CRP: '中铁国际多式联运 (CRP)',
          KR: '哈萨克斯坦铁路 (KTZ)',
          RZD: '俄罗斯铁路 (RZD)',
          UTLC: 'UTLC 欧亚铁路',
          PKP: '波兰铁路 (PKP)',
          other: '其他（请填写）',
          separator: '━━ 租户自定义 ━━'
        },
        containerType: {
          '20GP': '20GP',
          '40GP': '40GP',
          '40HC': '40HC 高箱',
          '45HC': '45HC 高箱',
          '20RF': '20RF 冷藏',
          '40RH': '40RH 冷藏',
          '20TK': '20TK 罐式',
          '20OT': '20OT 开顶'
        }
      },
      messages: {
        loadFailed: '加载铁路询价失败',
        saveDraftSuccess: '草稿保存成功',
        saveDraftFailed: '保存草稿失败',
        publishSuccess: '铁路询价单已发布',
        publishFailed: '发布询价失败',
        submitSuccess: '铁路询价单已提交',
        submitFailed: '提交询价失败',
        resetSuccess: '已重置表单',
        emailSent: '询价邮件已发送',
        emailNotImplemented: '询价邮件发送功能暂未接入',
        matchRatesComingSoon: '铁路运价匹配功能即将上线',
        aiComingSoon: 'AI 识别功能即将上线',
        requiredFieldsPrefix: '请完善必填项：',
        selectServiceTypeFirst: '请先选择服务类型',
        allInPriceTip: '开启后，供应商报价时可填写全包一口价',
        totalSummary: '合计：{pieces} 件 / {weight} KGS / {volume} CBM',
        densitySummary: '密度：{density} KG/CBM',
        priceSegmentEnabled: '干线、港前、尾程价格至少开启一个',
        priceSegmentActive: '价格段已启用',
        containerGroupLabel: '箱组 {index}',
        containerTotalSummary: '合计：{pieces} 件 / {weight} KGS',
        fullLoadSummary: '{vehicles} 辆 / {pieces} 件 / {weight} KGS',
        bulkTotalSummary: '合计：{pieces} 件 / {weight} KGS',
        switchServiceTypeConfirm: '切换服务类型将清空已填写的货物信息，是否继续？',
        deadlineFutureRequired: '报价截止时间必须晚于当前时间'
      },
      ai: {
        uploadTitle: '点击或拖拽上传询价文件',
        uploadDesc: '支持 JPG/PNG/PDF/Excel/Word 格式',
        tip: '如仅询价港前费用与尾程费用，请在提供的信息前分别标明「港前」「尾程」。',
        recognizedCount: '已识别 {count} 个字段',
        confirmLowConfidence: '请确认'
      },
      matchRates: {
        title: '匹配运价',
        empty: '暂无匹配运价',
        valid: '有效',
        expiringSoon: '即将过期',
        unitPrice: '单价',
        minCharge: '最低消费',
        flight: '车次',
        pending: '待定',
        validity: '有效期',
        route: '线路'
      },
      confirm: {
        switchServiceTypeTitle: '切换服务类型',
        switchServiceTypeContent: '切换服务类型将清空已填写的货物信息，是否继续？'
      },
      agent: {
        title: 'Agent 询价',
        greeting: '您好！我来帮您填写铁路询价单。<br />请问货物从哪个国家出发，到哪个国家？铁路公司是哪家？',
        send: '发送',
        switchToAi: '切换至 AI 识别',
        clearChat: '清空对话'
      },
      detail: {
        title: '铁路询价详情',
        totalQuotes: '共 {count} 家报价',
        sentSuppliersWithCount: '已发送供应商 ({count}家)',
        contact: '联系人',
        quotedAt: '报价时间',
        sections: {
          inquiryInfo: '询价信息',
          quotationSummary: '报价汇总'
        },
        columns: {
          supplier: '供应商',
          quotationNo: '报价编号',
          serviceType: '服务类型',
          routeType: '线路分类',
          charges: '费用',
          validPeriod: '有效期',
          submitDate: '提交时间',
          trainDepartureTime: '发车时间',
          trainArrivalTime: '到站时间',
          borderCrossTime: '出境时间',
          demurrageFreeDays: '免堆存天数',
          overweightRemarks: '限重说明',
          chargeName: '费用项',
          unitRate: '单价',
          amount: '金额',
          confirmStatus: '确认状态',
          consultStatus: '磋商状态'
        },
        actions: {
          refresh: '刷新',
          confirmSupplier: '确认供应商',
          cancelConfirm: '取消确认',
          negotiate: '磋商'
        },
        status: {
          unconfirmed: '未确认',
          confirmed: '已确认',
          imported: '已入库',
          quoted: '已报价',
          pending: '待报价',
          notConsulted: '未磋商',
          consulting: '磋商中',
          consultCompleted: '磋商完成'
        },
        help: {
          beforeConfirm: '确认供应商前可发起磋商与供应商沟通价格细节。',
          afterConfirm: '确认供应商后可取消确认重新选择。'
        },
        modal: {
          quotationDetail: '报价详情',
          charges: '费用明细',
          noCharges: '暂无费用',
          initiateConsultation: '发起磋商',
          expectedPrice: '期望价格',
          expectedPricePlaceholder: '请输入期望价格',
          consultationNote: '磋商说明'
        },
        confirm: {
          cancelTitle: '取消确认',
          cancelContent: '确认取消当前已确认供应商吗？'
        },
        messages: {
          loadQuotationFailed: '铁路报价加载失败',
          selectQuotationFirst: '请先选择一条报价',
          confirmSuccess: '供应商确认成功',
          confirmFailed: '供应商确认失败',
          cancelConfirmSuccess: '已取消确认',
          cancelConfirmFailed: '取消确认失败',
          consultSuccess: '已发起磋商',
          consultFailed: '发起磋商失败',
          consultUnavailable: '当前报价状态不可磋商',
          expectedPriceRequired: '请填写期望价格'
        }
      }
    },

    // 操作按钮
    actions: {
      view: '查看',
      detail: '详情',
      edit: '编辑',
      more: '更多',
      cancelSelection: '取消选择',
      submit: '提交',
      revoke: '撤回',
      delete: '删除',
      copy: '复制',
      confirmSupplier: '确认供应商',
      cancelConfirmSupplier: '取消确认供应商'
    },

    // 状态显示
    status: {
      pending: '待报价',
      quoted: '已报价',
      notEnabled: '无需报价',
      rejected: '拒绝报价',
      notQuoted: '未报价',
      notConsulted: '未磋商',
      consulting: '磋商中',
      consultationCompleted: '磋商完成'
    },

    // 确认对话框
    confirmDialog: {
      submitTitle: '确认提交',
      submitContent: '确定要提交询价 "{inquiryNo}" 吗？',
      submitOk: '确定提交',
      submitCancel: '取消',
      revokeTitle: '确认撤回',
      revokeContent: '确定要将询价 "{inquiryNo}" 撤回为草稿状态吗？',
      revokeOk: '确定撤回',
      revokeCancel: '取消',
      deleteTitle: '确认删除',
      deleteContent: '确定要删除询价 "{inquiryNo}" 吗？',
      batchDeleteTitle: '批量删除确认',
      batchDeleteContent: '确定要删除选中的 {count} 条记录吗？'
    },

    // 复制确认对话框
    copyConfirm: {
      title: '确认复制询价单',
      description: '确认要复制此询价单吗？复制后将创建一个新的草稿询价单。',
      detailTitle: '询价单详情',
      inquiryNo: '询价单编号'
    },

    // 视图模板
    viewTemplate: {
      noTemplateTitle: '未配置视图模板',
      noTemplateSubtitle: '该业务类型尚未发布询价视图模板，请先在平台管理端创建并发布。'
    },

    // 消息提示
    messages: {
      dataLoadFailed: '询价数据加载失败',
      selectRecordsFirst: '请先选择要删除的记录',
      noDataToExport: '没有可导出的数据',
      exportSuccess: '成功导出 {count} 条记录为 {type} 格式',
      exportFailed: '导出 {type} 格式失败，请稍后重试',
      submitSuccess: '询价提交成功',
      submitFailed: '提交失败，请稍后重试',
      revokeSuccess: '询价已撤回为草稿状态',
      revokeFailed: '撤回失败，请稍后重试',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      copySuccess: '复制成功',
      copyFailed: '复制失败，请稍后重试',
      batchDeleteSuccess: '批量删除成功',
      batchDeleteFailed: '批量删除失败',
      alreadyDraft: '询价已是草稿状态，无需撤回',
      onlySubmittedCanRevoke: '只有已提交的询价才能撤回为草稿',
      invalidStatusForAction: '无效的询价状态',
      cannotDeleteRecords: '已提交询价无法删除，请检查选中记录'
    },

    // 未读通知
    notifications: {
      title: '消息提醒',
      prePortQuoted: '头程已报价',
      trunkLineQuoted: '干线已报价',
      lastMileQuoted: '尾程已报价',
      allQuoted: '已完成全部报价'
    },

    // 自定义表格弹窗
    customTableModal: {
      title: '自定义表格字段',
      description: '选择要显示的表格字段',
      resetButton: '重置'
    },

    // 导出
    export: {
      filename: '询价数据'
    },
    // 详情页相关
    detail: {
      stuffingSection: '港前装箱门点',
      stuffingTerminal: '运港码头/堆场',
      stuffingTerminalPlaceholder: '请选择码头/堆场',
      deliveryTerminal: '到港码头/堆场',
      deliveryTerminalPlaceholder: '请选择码头/堆场',
      stuffingCountry: '国家',
      stuffingProvince: '省/州',
      stuffingCity: '市',
      stuffingDistrict: '区/县',
      stuffingStreet: '乡/镇/街道',
      stuffingCommunity: '社区',
      postalCode: '邮编',
      detailAddress: '详细地址',
      assignType: '回填目标'
    },
    filterPlaceholders: {
      enterInquiryNo: '请输入询价编号',
      selectSource: '请选择询价来源',
      selectInquirer: '请选择询价人',
      selectStatus: '请选择询价状态',
      selectCarrier: '请选择船公司',
      selectTrunkLineStatus: '请选择干线报价状态',
      selectPrePortStatus: '请选择头程报价状态',
      selectLastMileStatus: '请选择尾程报价状态',
      selectCargoReadyTimeType: '请选择货好时间类型',
      selectCargoReadyTimeRange: '请选择货好时间区间',
      selectCargoReadyTimeDate: '请选择货好时间范围',
      selectPalletNature: '请选择货盘性质',
      selectDirectTransit: '请选择直达/中转',
      selectRoute: '请选择航线',
      selectPol: '请选择起运港',
      selectPod: '请选择卸货港',
      selectDischargingPort: '请选择卸货港',
      selectCargoType: '请选择货物类型',
      selectServiceTerm: '请选择服务条款',
      enterCustomServiceTerm: '请输入自定义服务条款',
      selectClientType: '请选择委托单位类型',
      enterClientTitle: '请输入委托单位名称',
      enterSeaEq: '请输入箱型箱量',
      enterRemarks: '请输入备注',
      selectDateCreated: '请选择创建时间范围',
      selectDateModified: '请选择修改时间范围',
      selectCreatedBy: '请选择创建人',
      selectModifiedBy: '请选择修改人'
    }
  },

  // 询价详情页
  inquiryDetail: {
    // 页面标题
    pageTitle: {
      create: '新增询价',
      edit: '询价详情',
      view: '询价详情',
      loading: '加载中...'
    },

    // 表单章节
    sections: {
      basicInfo: '基本信息',
      cargoInfo: '货物信息',
      loadingPoint: '装箱门点',
      deliveryAddress: '尾程送货地址',
      containerInfo: '箱型箱量',
      matchPrice: '匹配运价',
      fclPrice: '干线运价',
      prePortPrice: '港前运价',
      lastMilePrice: '尾程运价',
      supplierQuotation: '供应商报价'
    },

    // 视图模板「服务类型货物区」
    viewCargo: {
      sectionTitle: '货物信息',
      empty: '暂无货物数据',
      noColumns: '当前服务类型未配置展示列',
      yes: '是',
      no: '否',
      ventilationOpen: '开',
      ventilationClose: '关',
      ventilationOpenWithQty: '开 {qty} CBM/H',
      serviceTypes: {
        FCL: '整箱',
        LCL: '拼箱',
        RORO: '滚装',
        BULK: '散杂',
        bulk: '散货',
        pallet: '整板',
        charterSpace: '整舱',
        fullCharter: '包机',
        container: '集装箱',
        fullLoad: '整车',
        default: '货物信息'
      },
      transportCategory: {
        '1': '各类车辆',
        '2': '轮式/履带设备',
        '3': '滚装托盘/单元货',
        '4': '加装行走轮大件构件',
        vehicle: '各类车辆',
        equipment: '轮式/履带设备',
        roro_pallet: '滚装托盘/单元货',
        oversized: '加装行走轮大件构件'
      },
      columns: {
        containerType: '箱型',
        containerNum: '箱量',
        piecesPerContainer: '件数/箱',
        weightPerContainer: '毛重(KGS)/箱',
        dimensions: '尺寸',
        temperatureRange: '温度要求',
        ventilation: '通风',
        humidity: '湿度',
        needPrecooling: '是否预冷',
        pieces: '件数',
        weightPerPiece: '单件毛重(KGS)',
        lengthM: '长(M)',
        widthM: '宽(M)',
        heightM: '高(M)',
        packageType: '包装类型',
        totalVolume: '总体积',
        transportCategory: '运输品类',
        vehicleType: '车辆类型',
        vehicleBrand: '车辆品牌',
        vehicleModel: '车辆型号',
        equipmentName: '设备名称',
        isCrawler: '履带式',
        isSelfPropelled: '自行移动',
        quantity: '数量',
        outerLengthM: '外长(M)',
        outerWidthM: '外宽(M)',
        outerHeightM: '外高(M)',
        weightKgs: '毛重(KGS)',
        isOversized: '是否超限',
        canDeckLoad: '甲板装载',
        specialFixingRequirement: '特殊固定要求',
        cargoName: '货物名称',
        package: '包装',
        stowageFactor: '积载因数',
        liftingRequirement: '吊装要求',
        lengthCm: '长(CM)',
        widthCm: '宽(CM)',
        heightCm: '高(CM)',
        remark: '备注',
        palletType: '板型',
        palletNum: '板量',
        volumeCbm: '体积(CBM)',
        truckType: '车型'
      }
    },

    // 复选框选项
    checkboxes: {
      prePortPrice: '港前价格',
      trunkLinePrice: '干线价格',
      lastMilePrice: '尾程价格'
    },

    // 附件上传
    attachments: {
      title: '附件上传',
      titleRequired: '附件上传 *',
      tip: '支持上传文档、图片、压缩包等文件，单个文件最大20MB，最多上传20个文件'
    },

    // 操作按钮
    actions: {
      saveDraft: '保存草稿',
      exportRate: '导出运价',
      exportQuotation: '导出报价',
      submit: '直接提交',
      cancel: '取消',
      back: '返回',
      aiRecognition: 'AI识别',
      add: '新增',
      matchPrice: '查询匹配运价',
      addContainerType: '添加箱型'
    },

    // 基本信息字段
    basicInfo: {
      inquiryNo: '询价编号',
      inquirerId: '询价人',
      palletNature: '货盘性质',
      cargoReadyTime: '货好时间',
      palletQuality: '货盘质量',
      serviceTerm: '服务条款',
      client: '委托单位',
      directTransit: '运输方式',
      detailAddress: '详细地址'
    },

    // 货物信息字段
    cargoInfo: {
      directTransit: '直达/中转',
      route: '航线',
      loadingPort: '起运港',
      destinationPort: '卸货港',
      dischargingPort: '卸货港',
      transitPort1: '中转港(1st)',
      transitPort2: '中转港(2nd)',
      transitPort3: '中转港(3rd)',
      cargoType: '货物类型',
      hazardClass: '危险品等级',
      unNo: 'UN No',
      temperature: '温度',
      ventilation: '通风量',
      quantity: '数量',
      cargoQuantity: '货量',
      weight: '重量',
      weightUnit: '重量单位',
      dimensions: '尺寸',
      dimensionsUnit: '尺寸单位',
      length: '长',
      width: '宽',
      height: '高',
      cargoDescription: '品名（HS Code）',
      containerRequirement: '用箱要求',
      transportTerms: '运输条款',
      cargoValue: '货值',
      cargoValueCurrency: '货值币种',
      carrier: '船公司',
      remarks: '备注'
    },

    // 装箱门点字段
    loadingPoint: {
      selectArea: '选择装箱门点区域',
      postalCode: '邮编',
      stuffingTerminal: '装箱码头/堆场',
      stuffingTerminalPlaceholder: '请选择码头/堆场',
      deliveryTerminal: '交货码头/堆场',
      deliveryTerminalPlaceholder: '请选择码头/堆场',
      country: '国家',
      province: '省份',
      city: '城市',
      district: '区/县',
      street: '街道/村镇',
      community: '社区',
      stuffingSection: '港前装箱门点',
      stuffingCountry: '国家',
      stuffingProvince: '省/州',
      stuffingCity: '市',
      stuffingDistrict: '区/县',
      stuffingStreet: '乡/镇/街道',
      stuffingCommunity: '社区',
      detailAddress: '详细地址',
      assignType: '分配目标'
    },

    // 尾程送货地址字段
    deliveryAddress: {
      addressInfo: '配送地址信息',
      addressType: '配送地址类型',
      postalCodeAndCountry: '邮编和国家',
      country: '请选择国家',
      postalCode: '请输入或选择邮编',
      provinceCity: '省市区',
      province: '省份',
      city: '城市',
      district: '区/县',
      detailAddress: '详细地址',
      amazonWarehouse: '亚马逊仓库选择',
      ecangWarehouse: '易仓仓库选择'
    },

    // 箱型箱量字段
    containerInfo: {
      containerType: '箱型',
      quantity: '数量',
      containerTypeAndQuantity: '箱型箱量：',
      rfTemperatureRequirement: '温度要求',
      rfVentilationRequirement: '通风要求',
      temperatureRange: '请输入温度范围，如：-20 至 30',
      temperatureStart: '起始温度',
      temperatureEnd: '结束温度',
      ventilationDoor: '通风门',
      ventilationOpen: '开',
      ventilationClose: '关',
      ventilationVolume: '风量',
      ventilationVolumeUnit: 'CBM/H',
      ventilationVolumePlaceholder: '请输入风量',
      humidity: '湿度',
      humidityPlaceholder: '请输入湿度',
      humidityUnit: '%RH',
      needPrecooling: '是否预冷',
      needPrecoolingYes: '是',
      needPrecoolingNo: '否',
      temperatureTo: '至',
      cargoQuantity: '件数',
      pieces: '件数',
      weight: '重量',
      weightUnit: '重量单位',
      dimensions: '尺寸',
      dimensionsUnit: '尺寸单位',
      length: '长',
      width: '宽',
      height: '高',
      temperatureUnit: '℃'
    },

    // 占位符文本
    placeholders: {
      autoGenerate: '自动生成',
      selectPalletNature: '请选择货盘性质',
      selectCargoReadyTimeRange: '请选择货好时间区间',
      selectCargoReadyDate: '请选择货好日期',
      selectOption: '请选择',
      inputServiceTerm: '请输入服务条款',
      selectClientType: '请选择客户类型',
      selectClient: '请选择客户',
      inputClientTitle: '请输入客户抬头',
      selectRoute: '请选择航线',
      selectLoadingPort: '请选择起运港',
      selectDestinationPort: '请选择卸货港',
      selectDischargingPort: '请选择卸货港',
      selectTransitPort1: '请选择第一中转港',
      selectTransitPort2: '请选择第二中转港',
      selectTransitPort3: '请选择第三中转港',
      selectHazardClass: '请选择危险品等级',
      inputUnNo: '请输入UN No',
      inputTemperature: '请输入温度',
      inputVentilation: '请输入通风量',
      enterInputQuantity: '请输入件数',
      inputWeight: '请输入重量',
      inputDimensions: '请输入尺寸',
      inputCargoDescription: '请输入品名或HS Code',
      selectContainerRequirement: '请选择用箱要求',
      selectTransportTerms: '请选择运输条款',
      inputCargoValue: '请输入货值',
      selectCargoValueCurrency: '请选择币种',
      selectCarrier: '请选择船公司',
      inputRemarks: '请输入备注信息',
      province: '省份',
      city: '城市',
      district: '区/县',
      street: '街道/村镇',
      inputDetailAddress: '请填入详细地址',
      selectCountry: '请选择国家',
      inputPostalCode: '请输入或选择邮编',
      inputDeliveryAddress: '请填入详细地址',
      selectAmazonWarehouse: '请选择亚马逊仓库',
      selectEcangWarehouse: '请选择易仓仓库',
      selectContainerType: '请选择箱型',
      inputQuantity: '数量',
      inputLoadingPointAddress: '请填入装箱门点地址',
      inputDeliveryAddressText: '请填入尾程送货地址',
      clickMatchPrice: '请点击"查询匹配运价"按钮获取运价信息',
      noFclMatches: '未查询到匹配的干线运价',
      noPrePortMatches: '未查询到匹配的港前运价',
      noLastMileMatches: '未查询到匹配的尾程运价',
      noFclPrices: '暂无干线运价方案',
      noPrePortPrices: '暂无港前运价方案',
      noLastMilePrices: '暂无尾程运价方案',
      quotePending: '待报价',
      quoteRejected: '拒绝报价',
      noFeeDetail: '暂无费用明细',
      quotationStatus: '报价状态',
      supplier: '供应商',
      allStatus: '全部状态',
      allSuppliers: '全部供应商',
      quoted: '已报价',
      imported: '已导入',
      confirmed: '已确认'
    },

    // 单位和后缀
    units: {
      celsius: '°C',
      kilogram: 'KGS'
    },

    // AI识别弹窗
    aiModal: {
      loadingPointTitle: 'AI智能识别地址',
      deliveryTitle: 'AI智能识别地址',
      loadingPointDesc: '请将地址信息粘贴到下方文本框中：',
      deliveryDesc: '请将美国地址信息粘贴到下方文本框中：',
      loadingPointTip: '提示：系统将自动解析省市区街道信息，详细地址将填入详细地址栏',
      deliveryRules: '识别规则：',
      deliveryRule1: '如包含亚马逊仓库代码(ONT8/BFI4等)，将自动设置为亚马逊仓库类型',
      deliveryRule2: '如包含易仓代码(LAX203/ATL205等)，将自动设置为易仓类型',
      deliveryRule3: '其他情况将设置为第三方地址，并解析地址和邮编',
      recognize: '识别',
      cancel: '取消'
    },

    // 下拉选项
    options: {
      alibaba: '阿里巴巴集团',
      jd: '京东物流有限公司',
      huawei: '华为技术有限公司',
      xiaomi: '小米科技有限公司',
      haier: '海尔集团公司',
      baosteel: '宝钢集团有限公司',
      cmg: '招商局集团',
      cosco: '中远海运集团'
    },

    // 消息提示
    messages: {
      saveDraftSuccess: '草稿保存成功',
      updateSuccess: '询价更新成功',
      submitSuccess: '询价提交成功',
      saveFailed: '保存失败',
      submitFailed: '提交失败',
      loadFailed: '加载询价详情失败',
      exportPending: '导出运价功能开发中...',
      addressRecognitionSuccess: '地址识别成功',
      inputAddressFirst: '请输入地址信息',
      confirmSubmit: '确认提交询价？',
      confirm: '确定',
      cancel: '取消',
      loading: '加载中...',
      noData: '无数据',
      copySuccess: '文本已复制到剪贴板',
      copyFailed: '复制失败，请手动复制',
      noAvailablePrices: '未找到可用的运价信息，请查询匹配运价并选择，或等待新的报价。',
      selectQuotedPriceFirst: '请先选择一个已报价的运价',
      loadTemplateFailed: '加载模板失败',
      openTemplateViewReportFailed: '打开模板查看报表失败',
      inquiryAllDisabled: '干线价格、港前价格和尾程价格至少要开启一个',
      doorPostalCodeRequired: '运输条款为DOOR时，邮编为必填项',
      doorDeliveryAddressRequired: '运输条款为DOOR时，配送详细地址为必填项',
      routeMatchSuccess: '航线匹配成功',
      routeMatchFailed: '未匹配到航线',
      addressRecognitionFailed: '地址识别失败',
      cargoDescriptionRequired: '运输条款为DOOR时，品名为必填项',
      cargoValueRequired: '服务条款为DDP时或运输条款为DOOR时，货值为必填项',
      cargoValueCurrencyRequired: '服务条款为DDP时或运输条款为DOOR时，货值币种为必填项',
      rfTemperatureStartRequired: '起始温度为必填项',
      rfTemperatureEndRequired: '结束温度为必填项',
      rfVentilationEnableRequired: '通风门为必填项',
      rfVentilationQuantityRequired: '风量为必填项',
      loadingPortSameAsDestination: '起运港和卸货港不能相同',
      destinationPortSameAsLoading: '卸货港和起运港不能相同',
      confirmSupplierSuccess: '供应商确认成功',
      confirmSupplierFailed: '确认供应商失败，请重试',
      confirmSupplierBlockedByConsulting: '磋商中的报价不允许确认供应商',
      cancelConfirmSupplierSuccess: '已取消供应商确认',
      cancelConfirmSupplierFailed: '取消确认失败，请重试',
      selectQuotationFirst: '请选择报价单',
      resetFailed: '重置失败，请重试',
      fillRequiredFields: '请填写必填项',
      orderAlreadyCreated: '已创建订单',
      orderNoPrefix: '订单号：',
      orderIndexPrefix: '订单{index}：',
      orderAlreadyGenerated: '该询价单已生成订单，无法再次订舱',
      quotationNotExist: '报价信息不存在，无法发起订舱',
      supplierFallback: '供应商'
    },

    // 导出运价弹窗
    exportQuotationModal: {
      title: '导出报价',
      containerTypeAndQuantity: '箱型箱量',
      copyQuotationText: '复制快捷报价文本',
      printQuotation: '打印报价单文件',
      printPending: '打印功能开发中'
    },

    // 快捷报价文本弹窗
    quotationTextModal: {
      title: '快捷报价文本',
      description: '以下是根据您选择的箱型箱量生成的报价文本，您可以复制后发送给客户：',
      placeholder: '请输入报价文本',
      close: '关闭',
      copyText: '复制文本'
    },

    // 报价文本内容
    quotationText: {
      title: '【询价报价单】',
      inquiryNo: '询价编号: ',
      inquiryType: '询价类型: ',
      fcl: '整箱',
      prePort: '港前',
      lastMile: '尾程',
      inquirer: '询价人: ',
      submitDate: '询价时间: ',
      containerTypeAndQuantity: '箱型箱量: ',
      routeInfo: '航线信息: ',
      loadingPort: '起运港: ',
      destinationPort: '卸货港: ',
      carrier: '船公司: ',
      directTransit: '直达/中转: ',
      priceDetails: '价格明细: ',
      trunkLineFee: '干线费用: ',
      prePortFee: '港前费用: ',
      lastMileFee: '尾程费用: ',
      feeCalculation: '费用计算: ',
      trunkLine: '干线: ',
      cargoReadyTime: '货好时间: ',
      client: '委托单位: ',
      remarks: '备注: ',
      priceDisclaimer: '※ 以上价格仅供参考，实际价格以正式合同为准',
      contactInfo: '※ 如有任何疑问，请联系我们的客服团队',
      notSpecified: '不指定',
      containerCharges: '按箱计费: ',
      otherCharges: '非按箱计费: ',
      totalQuotes: '共 {count} 条报价',
      selectedQuotation: '已选报价：',
      syncNotice: '将基础海运费写入运价维护；附加费费用同步至附加费管理',
      oceanFreightCost: '基础海运费（成本）',
      oceanSurchargesCost: '海运附加费',
      originPortFee: '起运港费用',
      destinationPortFee: '目的港费用',
      unitBox: '箱',
      unitTicket: '票',
      selectedForImport: '已勾选 {count} 条待导入'
    },

    // 运价显示标签
    priceDisplay: {
      priceNo: '运价编号',
      carrierName: '船公司',
      validPeriod: '有效期',
      directTransit: '直达/中转',
      direct: '直达',
      transit: '中转',
      voyageDays: '航程',
      days: '天',
      detentionFreeDays: '免用箱期',
      demurrageFreeDays: '免堆存期',
      containerCharges: '按箱计费',
      otherCharges: '非按箱计费',
      supplier: '供应商',
      priceMethod: '运价类型',
      agentName: '代理名称',
      basicSeaFee: '基础海运费',
      surcharge: '附加费'
    },

    // 邮编相关
    zipCode: {
      loading: '加载中...',
      loadProvincesFailed: '加载省份失败',
      loadCitiesFailed: '加载城市失败',
      loadDistrictsFailed: '加载区县失败',
      loadStreetsFailed: '加载街道失败',
      loadZipCodesFailed: '加载邮编失败',
      zipCodeQueryFailed: '邮编查询失败',
      zipCodeLoadSuccess: '中国邮编加载成功',
      loadContainerTypesFailed: '加载集装箱类型数据失败',
      containerTypesLoadSuccess: '集装箱类型数据加载成功'
    },

    // 表格列
    columns: {
      feeName: '费用名称',
      currency: '币种',
      unitRate: '单价',
      measure: '单位',
      remarks: '备注'
    },

    validation: {
      entrustingUnitRequired: '请选择委托单位',
      salesBranchRequired: '请选择销售分公司'
    },

    unifiedCreate: {
      businessType: {
        fcl: '整箱询价',
        lcl: '拼箱询价',
        air: '空运询价',
        express: '快递询价',
        rail: '铁路询价',
        prePort: '港前询价',
        lastMile: '尾程询价'
      },
      actions: {
        reset: '重置'
      },
      sections: {
        businessInfo: '{business}信息'
      },
      template: {
        loaded: '模板已加载',
        noPublished: '暂无已发布模板',
        noPublishedAlert: '当前询价类型暂无已发布表单模板，请先在平台端发布询价模板。',
        loadFirst: '请先加载询价表单模板'
      },
      priceDisplay: {
        agent: '代理',
        supplier: '供应商',
        chargeDetails: '费用明细'
      },
      match: {
        pending: '请点击“查询匹配运价”按钮获取运价信息',
        empty: '暂无{type}',
        failed: '匹配运价失败',
        noMatchedPrice: '暂无匹配运价'
      },
      validation: {
        upload: '请上传{field}',
        select: '请选择{field}',
        input: '请填写{field}',
        checkRequired: '请检查必填项和字段规则',
        passed: '校验通过',
        deadlineFutureRequired: '报价截止时间必须晚于当前时间'
      },
      messages: {
        resetTip: '请按当前表单字段逐项调整'
      }
    }
  },

  // ======== AI询价识别 行内面板 ========
  aiInquiryRecognition: {
    upload: {
      title: '点击或拖拽上传询价文件',
      supportedFormats: '支持 JPG/PNG/PDF/Excel/Word 格式'
    },
    warning: '如果是仅询港前/尾程费用，请在提供的信息前分别清晰备注“港前”、“尾程”字样。',
    textPlaceholder: '请粘贴需要识别的文本内容，例如：\nFrom CNSHA/Shanghai to USLAX/Los Angeles\nCarrier: Maersk\nContainer: 2x20GP + 1x40HC\nWeight: 1200 KGS\n直达, Service terms: DDP\n货物类型: 普货;\n上海货运代理服务有限公司\n\n装箱门点：系统将自动解析省市区街道信息，详细地址将填入详细地址栏；\n\n尾程送货地址：若识别到仓库代码将自动设置仓库类型，其他情况将设置为第三方地址并解析地址和邮编；',
    startButton: '开始识别',
    messages: {
      emptyInput: '请上传文件或输入文本内容',
      error: 'AI识别失败，请重试',
      filledCount: 'AI识别完成，本次共填入 {filled} 个字段',
      noResult: '未识别到有效信息，请检查输入内容'
    }
  },

  // ======== 地址分配弹窗 ========
  addressAllocModal: {
    title: '地址分配',
    description: '以下地址无法自动识别，请手动分配到对应的字段：',
    unknownAddress: '待识别地址',
    selectPlaceholder: '请选择',
    options: {
      stuffing: '港前装箱门点',
      delivery: '尾程送货地址'
    },
    cancel: '取消',
    confirm: '确认回显'
  }
}
